// This function will sort the subheadings alphabetically

function sortListSubheadingsAlphabetical(listSubheadings) {
  const sortedListSubheadings = listSubheadings.sort((a, b) => {
    if (a.subheading < b.subheading) {
      return -1;
    }
    if (a.subheading > b.subheading) {
      return 1;
    }
    return 0;
  });

  return sortedListSubheadings;
}

export default sortListSubheadingsAlphabetical;
